import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { OrganizationDetail } from '../../organizations/components/OrganizationDetail';
import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const PrejimkaNewOrganizationPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
          resource='Organizations'
          action='create.view'
        >
          <OrganizationDetail />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaNewOrganizationPage;
